import React from 'react';

import { useEscapeToClose } from '../hooks/useEscapeToClose';
const ParentalHistoryView = ({ isOpen, onClose, data }) => {
  useEscapeToClose(onClose);   // Escape dismisses this modal
  if (!isOpen) return null;

  // Handle empty or null data
  const safeData = data || {};
  const fatherInfo = safeData.father_info || {};
  const motherInfo = safeData.mother_info || {};
  const parentalConditions = safeData.parental_conditions || {};

  // Get conditions by category
  const getConditionsByCategory = () => {
    const conditionsByCategory = {};
    
    Object.entries(parentalConditions).forEach(([condition, parents]) => {
      if (parents.father || parents.mother) {
        const category = 'Medical Conditions';
        if (!conditionsByCategory[category]) {
          conditionsByCategory[category] = [];
        }
        conditionsByCategory[category].push({
          name: condition,
          father: parents.father,
          mother: parents.mother
        });
      }
    });
    
    return conditionsByCategory;
  };

  const conditionsByCategory = getConditionsByCategory();
  const hasConditions = Object.keys(conditionsByCategory).length > 0;
  const hasParentInfo = (fatherInfo.isDeceased !== undefined) || (motherInfo.isDeceased !== undefined);

  return (
    <div className="modal-overlay">
      <div className="modal-content parental-history-modal">
        <div className="modal-header">
          <h2>Parental Medical History - View Only</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-body">
          {/* Parent Information */}
          {hasParentInfo && (
            <div className="parent-info-section">
              <h3 className="phv-parentInfoTitle">Parent Information:</h3>
              
              <div className="parent-info-display phv-parentInfoDisplay">
                {/* Father Info */}
                <div className="phv-fatherSection">
                  <h4 className="phv-fatherTitle">Father</h4>
                  <div>
                    <strong>Status:</strong> {fatherInfo.isDeceased ? 'Deceased' : 'Living'}
                  </div>
                  {fatherInfo.isDeceased && fatherInfo.dateDeceased && (
                    <div className="phv-fatherDeathDate">
                      <strong>Date of Death:</strong> {new Date(fatherInfo.dateDeceased).toLocaleDateString()}
                    </div>
                  )}
                </div>

                {/* Mother Info */}
                <div className="phv-motherSection">
                  <h4 className="phv-motherTitle">Mother</h4>
                  <div>
                    <strong>Status:</strong> {motherInfo.isDeceased ? 'Deceased' : 'Living'}
                  </div>
                  {motherInfo.isDeceased && motherInfo.dateDeceased && (
                    <div className="phv-motherDeathDate">
                      <strong>Date of Death:</strong> {new Date(motherInfo.dateDeceased).toLocaleDateString()}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Family Medical Conditions */}
          {hasConditions ? (
            <div className="conditions-summary">
              <h3 className="phv-conditionsTitle">Family Medical Conditions:</h3>
              {Object.entries(conditionsByCategory).map(([category, conditions]) => (
                <div key={category} className="phv-conditionCategory">
                  <h4 className="phv-categoryName">
                    {category}
                  </h4>
                  <div className="phv-conditionsList">
                    {conditions.map((condition, index) => (
                      <div key={index} className="phv-conditionItem">
                        <div className="phv-conditionName">
                          {condition.name}
                        </div>
                        <div className="phv-parentAffiliation">
                          <div>
                            <strong>Father:</strong>
                            <span className="phv-fatherFlag" style={{ color: condition.father ? 'var(--color-success)' : '#6c757d' }}>
                              {condition.father ? 'Yes' : 'No'}
                            </span>
                          </div>
                          <div>
                            <strong>Mother:</strong>
                            <span className="phv-motherFlag" style={{ color: condition.mother ? 'var(--color-success)' : '#6c757d' }}>
                              {condition.mother ? 'Yes' : 'No'}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="phv-emptyState" style={{ marginTop: hasParentInfo ? '16px' : '0' }}>
              <p>No family medical conditions have been recorded.</p>
            </div>
          )}

          {/* Empty state */}
          {!hasParentInfo && !hasConditions && (
            <div className="phv-noHistoryState">
              <p>No parental medical history has been recorded yet.</p>
              <p className="phv-emptyStateHint">
                Click "Edit Parental History" to add family medical information.
              </p>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="cancel-button" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default ParentalHistoryView;